"use strict";

import { Observer, observer } from "mobx-react";
import React from "react";
var LayerContext = React.createContext({
  currentZIndex: 0
});
var Layer = observer(function (_ref) {
  var children = _ref.children,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? 1 : _ref$offset;
  return /* @__PURE__ */React.createElement(LayerContext.Consumer, null, function (_ref2) {
    var currentZIndex = _ref2.currentZIndex;
    return /* @__PURE__ */React.createElement(Observer, null, function () {
      return /* @__PURE__ */React.createElement(LayerContext.Provider, {
        value: {
          currentZIndex: currentZIndex + offset
        }
      }, children({
        zIndex: currentZIndex + offset
      }));
    });
  });
});
var OVERLAY_ZINDEX = 890;
var AngularOverlayProvider = observer(function (_ref3) {
  var children = _ref3.children;
  return /* @__PURE__ */React.createElement(LayerContext.Provider, {
    value: {
      currentZIndex: OVERLAY_ZINDEX
    }
  }, children);
});
export { AngularOverlayProvider, Layer };